/* eslint-disable react/prefer-stateless-function */

import React from 'react';

class ModalContent extends React.Component {
  static defaultProps = {
    children: [],
  };

  render() {
    return (
      <div className="modal-content">
        <div className="modal-body">{this.props.children}</div>
      </div>
    );
  }
}

export default ModalContent;
